/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import { init } from 'ccui-shared/legacy-dep-bootstrap/shim/requirejs';

init();
